import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";
import axios from "axios";
import config from "../../services/config.json";
import { DatePicker, Row, Col, Switch } from "antd";

const Events = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
  });

 const activateEvent = async (record) => {

    setData((prevData) =>
      prevData.map((item) =>
        item.id === record.id ? { ...item, active: item.active == 1 ? 0 : 1 } : item
      )
    );
  try {
    const response = await axios.post(`${config.apiEndPoint}recover_events`, {
      id: record.id,
    });

  } catch (error) {
    console.error('Error activating event:', error);
  }
};

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    fetchData({ pagination: { ...pagination, current: 1 }, filters: newFilters });
  };
  

  const fetchData = async (params = {}) => {
    setLoading(false);
    try {
        const response = await axios.get(`${config.apiEndPoint}deleted_events`, {
            params: {
                page: params.pagination?.current || 1,
                per_page: params.pagination?.pageSize || 15,
                name: params.filters?.name || "",
                id: params.filters?.id || "",
                title: params.filters?.title || "",
                updated_at: params.filters?.updated_at || "",
                active: params.filters?.active || "",
                author_name: params.filters?.author_name || "",
              },
      });

      const result = response.data;

      setData(result.events);
      setPagination({
        current: result.current_page,
        pageSize: result.per_page,
        total: result.total,
      });
    } catch (error) {
      console.error("Failed to fetch event:", error);
    }
    setLoading(false);
  };
  

  useEffect(() => {
    fetchData({ pagination, filters });
  }, []);

  const handleTableChange = (pagination) => {
    fetchData({ pagination, filters });
  };

  const columns = [
    {
        title: "No.",
        key: "index",
        render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
      },
    {
        title: "Title",
        dataIndex: "title",
        key: "title",
        render: (text) => {
            if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
  },
      },
      {
        title: "Author Name",
        dataIndex: "author_name",
        key: "author_name",
        render: (text) => {
            if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
  },
      },
    {
  title: "Image",
  dataIndex: "images",
  key: "images",
  render: (text) => {
    return (
      <img
        src={text ? text : ""}
        alt="Event Image"
        style={{ width: '150px', height: 'auto', objectFit: 'contain' }}
      />
    );
  },
},
      {
        title: "Status",
        dataIndex: "active",
        key: "active",
       render: (text, record) => (
    <Switch
      checked={text == 1 || text == true}
      onChange={() => activateEvent(record)}
      style={{
    backgroundColor: (text == 1 || text == true) ? '#dab35c' : undefined,
  }}
    />
  ),
      },
       {
        title: "Deletion Date",
        dataIndex: "updated_at",
        key: "updated_at",
       render: (text) => {
  return (text && text !== 'null') ? text.split(' ')[0] : '-';
}
      },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Deleted Events</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 16, marginTop: 25 }}>
      <Input
    placeholder="Filter by Name"
    value={filters.name}
    onChange={(e) => handleFilterChange("name", e.target.value)}
    style={{ width: 220 }}
  />

</div>



      <Table
        columns={columns}
        rowKey={(record, index) => record.id || index}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Events;